import { render, staticRenderFns } from "./FileMediaComponent.vue?vue&type=template&id=3fa88f2a&scoped=true&"
import script from "./FileMediaComponent.vue?vue&type=script&lang=js&"
export * from "./FileMediaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa88f2a",
  null
  
)

export default component.exports